import type { ReactElement } from 'react';
import { Fragment } from 'react';

import Address from 'models/Address';
import RadioButton from '../RadioButton';

type Props = {
  addresses: Address[];
  selectedId: number;
  isPrimaryEditable?: boolean;
  onSelect: (address: Address) => void;
  onEdit: (address: Address) => void;
};

function AddressSelector({
  addresses,
  selectedId,
  isPrimaryEditable = false,
  onSelect,
  onEdit,
}: Props): ReactElement {
  return (
    <div className="c-scheduled-addresses">
      <hr />
      {addresses.map((address, index) => (
        <Fragment key={address.id}>
          <div className="c-scheduled-addresses__select-address">
            <RadioButton
              id={`addr-${address.id}`}
              label={(
                <>
                  <strong>Ship to:</strong>
                  {index === 0 && '(Primary)'}
                </>
              )}
              name="address"
              onChange={() => onSelect(address)}
              checked={selectedId === address.id}
            />
          </div>

          <div className="c-scheduled-addresses__address">
            {address.fullName}
            <br />
            {`${address.firstLine} ${address.secondLine}`}
            <br />
            {address.lastLine}
            <br />
            {`Tel: ${address.local_phone_number}`}
          </div>

          {(!address.primary || isPrimaryEditable) && (
            <div className="c-scheduled-addresses__edit">
              <button
                type="button"
                className="c-link"
                onClick={() => onEdit(address)}
              >
                Edit
              </button>
            </div>
          )}

          <div style={{ clear: 'both' }} />
          {index !== addresses.length - 1 && <hr />}
        </Fragment>
      ))}
    </div>
  );
}

export default AddressSelector;
